// extracted by mini-css-extract-plugin
export default {"item":"Legend_item__2btwV","item_hidden":"Legend_item_hidden__wa2qd","icon":"Legend_icon__s5jDG"};